var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input-container npvWidth",
      class: { "required-fail": _vm.requiredFail }
    },
    [
      _c("input", {
        staticClass: "no-border npvStyling",
        attrs: {
          type: "number",
          disabled: _vm.disabled,
          placeholder: _vm.placeholder,
          min: _vm.min,
          max: _vm.max,
          step: _vm.step ? _vm.step : _vm.autoNumberFieldStep,
          id: _vm.fieldId
        },
        domProps: { value: _vm.value },
        on: {
          input: function($event) {
            return _vm.updateValueNum($event.target.value)
          },
          keypress: _vm.checkInput
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c909854", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c909854","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Npv/Configuration/components/InputTypesNPV/InputTypeNumberNPV.vue
// module id = null
// module chunks = 